import { render } from "./InputEmailResetPassword.vue?vue&type=template&id=251084fb&ts=true"
import script from "./InputEmailResetPassword.vue?vue&type=script&lang=ts"
export * from "./InputEmailResetPassword.vue?vue&type=script&lang=ts"

import "./InputEmailResetPassword.vue?vue&type=style&index=0&id=251084fb&lang=scss"

import exportComponent from "/builds/likeacoffee.com/time-assistantv3-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__